module.exports = __webpack_public_path__ + "Roboto-Thin.ba422f71e799f3d29cbf.svg";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Thin.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Thin.svg
// module chunks = 16